import styled from "styled-components";
import { Link as LinkR } from "react-router-dom";
import { Link as LinkS } from "react-scroll";

export const Nav = styled.nav`
  
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 1px solid #0000001F;
  box-shadow: 0px 4px 4px 0px #00000005;
  background: #FFFFFF;




  @media screen and (max-width: 960px) {
    transition: 0.8s all ease;
  }

  @media screen and (max-width:480px) {
    height: 60px;
    transition: 0s all ease-in-out;
  }
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  z-index: 10;
  width: 100%;
  padding: 0 20px;
`;

export const NavLogo = styled(LinkR)`
  display: flex;
  align-items: center;
  justify-self: flex-start;
  cursor: pointer;
  text-decoration: none;

  @media screen and (max-width: 768px) {
    margin-left: 0px;
  }

  @media screen and (max-width: 480px) {
    margin-left: 0px;
    margin-top: 0px;
  }
`;
export const SvgLogo = styled.img`

`;

export const MobileIcon = styled.div`
  display: none;
  color: #000000 !important;

  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: -10px;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
    color: #000000 !important;
  }

  @media screen and (max-width: 480px) {
    font-size: 1.5em;
  }
`;

export const SidebarMobileIcon = styled.div`
  display: none;

  @media screen and (max-width: 768px) {
    display: contents;
    position: absolute;
    top: -45px;
    /* right: 0; */
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
    color: #fff;
  }

  @media screen and (max-width: 480px) {
    font-size: 1.5em;
    /* top: -5px; */
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  margin-bottom: 0;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;
export const NavItem = styled.li`
  height: 80px;
`;

export const NavLinks = styled.div`
  color: #fff;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 1rem;
  height: 100%;
  cursor: pointer;
  font-size: 1em;
  font-weight: 400;
`;

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const NavBtnLink = styled(LinkR)`
  margin: 0.4em;
  border-radius: 4px;
  white-space: nowrap;
  padding: 0.25em 1em;
  color: ${(props) => (props.primary ? "#F1F1F1" : "#F1F1F1")};
  background: ${(props) => (props.primary ? "transparent" : "#FF4001")};
  border: 1px solid ${(props) => (props.primary ? "#FFFFFF" : "#FF4001")};
  font-size: 1em;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${(props) => (props.primary ? "transparent" : "#FF4001")};
    color: ${(props) => (props.primary ? "FFFFFF" : "#FFFFFF")};
  }
`;

export const LoginTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LoginCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const LoginAnchor = styled.a`
  color: #2b3bf6;
`;

export const NavIcon = styled(LinkR)`
  margin-left: 2rem;
  font-size: 2rem;
  height: 80px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  @media screen and (max-width: 480px) {
    font-size: 1.5rem;
  }
`;
